<template>
  <mdb-container class="bv-example-row wrapper">
    <mdb-row class="justify-content-md-center firstrow">
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[0].id}`">
            <mdb-view class="view" hover :src="listArray[0].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[0].brandDescription + ' ' + listArray[0].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[0].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[0].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[1].id}`">
            <mdb-view class="view" hover :src="listArray[1].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[1].brandDescription + ' ' + listArray[1].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[1].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[1].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[2].id}`">
            <mdb-view class="view" hover :src="listArray[2].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[2].brandDescription + ' ' + listArray[2].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[2].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[2].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[3].id}`">
            <mdb-view class="view" hover :src="listArray[3].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[3].brandDescription + ' ' + listArray[3].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[3].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[3].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[4].id}`">
            <mdb-view class="view" hover :src="listArray[4].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[4].brandDescription + ' ' + listArray[4].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[4].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[4].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[5].id}`">
            <mdb-view class="view" hover :src="listArray[5].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[5].brandDescription + ' ' + listArray[5].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[5].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[5].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[6].id}`">
            <mdb-view class="view" hover :src="listArray[6].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[6].brandDescription + ' ' + listArray[6].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[6].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[6].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[7].id}`">
            <mdb-view class="view" hover :src="listArray[7].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[7].brandDescription + ' ' + listArray[7].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[7].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[7].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[8].id}`">
            <mdb-view class="view" hover :src="listArray[8].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[8].brandDescription + ' ' + listArray[8].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[8].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[8].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[9].id}`">
            <mdb-view class="view" hover :src="listArray[9].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[9].brandDescription + ' ' + listArray[9].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[9].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[9].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[10].id}`">
            <mdb-view class="view" hover :src="listArray[10].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[10].brandDescription + ' ' + listArray[10].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[10].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[10].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[11].id}`">
            <mdb-view class="view" hover :src="listArray[11].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[11].brandDescription + ' ' + listArray[11].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[11].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[11].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[12].id}`">
            <mdb-view class="view" hover :src="listArray[12].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[12].brandDescription + ' ' + listArray[12].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[12].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[12].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link :to="`/estimate/${listArray[13].id}`">
            <mdb-view class="view" hover :src="listArray[13].srcImg" alt="">
              <a>
                <h5 class="crazycar">
                  {{listArray[13].brandDescription + ' ' + listArray[13].name}}
                </h5>
              </a>
              <a class="crazya"><h6 class="blinking">월 {{listArray[13].monthlyPrice }}만원</h6></a>
              <a class="crazya"><h6 class="blinking">금리 {{listArray[13].interestRate }}%</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-row>
  </mdb-container>
</template>

<script>
export default {
  name: 'HoverEffect',
  props: {
    listArray: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.firstrow {
  margin: 0px 0px !important;
  max-height: 3000px !important;
  justify-content: center!important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
}

.wrapper {
  background-color: white;
  max-width: 100%;
  height: auto;
  margin: 0px 0px;
  padding: 0px 0px;
}

.secondrow {
  max-width: 100%;
  height: auto;
  background-color: white !important;
  align-items: center;
}

.crazycar {
  text-align: center;
  color: black;
  background-color: white;
  line-height: 100%;
  margin-bottom: 0px;
  padding-top: 0 0px;
  font-family: "Proxima Nova";
  font-size: 20px;
  font-weight: 500;
}

.crazya {
  color: black !important;
}

.col {
  align-items: center;
  max-height: 350px;
  max-width: 337px;
}

.bcol {
  align-items: center;
  max-height: 350px;
  max-width: 337px;
  padding: 0 0px;
}

.view {
  max-width: 70%;
  max-height: 70%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 10%;
  margin-bottom: 10%;
  align-items: center;
}

.overlay {
  max-width: 100%;
  max-height: 100%;
  padding: 0px 0px;
}

.blinking{
  animation:blinkingText 2s infinite;
  background-color: white;
  text-align: center;
  font-weight: 900;
  line-height: 100%;
  margin-bottom: 0px;
  padding-top: 0 0px;
  color: black;
}

.blinkingrate{
  animation:blinkingText 2s infinite;
  background-color: white;
  text-align: center;
  font-weight: 500;
  line-height: 100%;
  margin-bottom: 0px;
  padding-top: 0 0px;
  color: black;
  font-size: 10px;
}

@keyframes blinkingText{
  30%{ color: #ffba00; }
  40%{ color: #ffba00; }
  50%{ color: #ffba00; }
  60%{ color :#ffba00; }
  70%{ color: #ffba00; }
}
</style>
